import { Check, Copy, Download } from "lucide-react";
import { useState } from "react";
import type { ReportCard } from "../lib/reports";

function downloadText(report: ReportCard) {
  const blob = new Blob([report.content], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = report.filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

async function copyText(text: string) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Browser preview over plain HTTP can deny Clipboard API; fall back to the legacy selection path.
    }
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "true");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  document.body.removeChild(textarea);
  if (!copied) {
    throw new Error("Copy command was rejected by the browser.");
  }
}

export function ReportCards({ reports }: { reports: ReportCard[] }) {
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const copyReport = async (report: ReportCard) => {
    await copyText(report.content);
    setCopiedId(report.id);
    window.setTimeout(() => setCopiedId(null), 1800);
  };

  if (!reports.length) {
    return <div className="empty">Reports become available after the payload loads.</div>;
  }

  return (
    <div className="report-grid">
      {reports.map((report) => (
        <article className="report-card" key={report.id}>
          <div>
            <span>{report.eyebrow}</span>
            <h3>{report.title}</h3>
            <p>{report.summary}</p>
          </div>
          <div className="report-actions">
            <button type="button" onClick={() => copyReport(report)}>
              {copiedId === report.id ? <Check size={16} /> : <Copy size={16} />}
              {copiedId === report.id ? "Copied" : "Copy"}
            </button>
            <button type="button" onClick={() => downloadText(report)}>
              <Download size={16} />
              TXT
            </button>
          </div>
        </article>
      ))}
    </div>
  );
}
